import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {FileSaverService} from 'ngx-filesaver';
import {CommonService} from '../../../services/common.service';
import {FileService} from '../../../services/file.service';
import {ResumeService} from '../../../services/resume.service';
import {ToastMessagesService} from '../../../services/toast-messages.service';
import {MatCheckboxChange} from '@angular/material/checkbox';
import {MatRadioChange} from '@angular/material/radio';
import {saveAs} from 'file-saver';


@Component({
  selector: 'app-resume-form',
  templateUrl: './resume-form.component.html',
  styleUrls: ['./resume-form.component.scss']
})
export class ResumeFormComponent implements OnInit {
  uniqueId: string;
  isLoading: boolean;
  uniqueToken: string;
  mode: string;
  form: any;
  id: number;
  isSubmitting: boolean;
  isSubmitted: boolean;
  isFinalizing: boolean;
  public confirmedClose: boolean;
  hasLinkedFields: boolean;
  selectedField: any;
  previewParam: number;
  twoFactorField: any;
  twoFactor = {
    display: false,
    message: '',
    identifier: '',
    value: ''
  };
  submittedForm: any = {};
  files = [];
  previewFiles = [];
  foundEmpty: boolean;
  isExporting: boolean;

  constructor(public route: ActivatedRoute,
              public router: Router,
              public commonService: CommonService,
              private fileSaverService: FileSaverService,
              private fileService: FileService,
              public toastService: ToastMessagesService,
              private resumeService: ResumeService) {
    this.isLoading = true;
    this.isSubmitting = false;
    this.confirmedClose = false;
    this.hasLinkedFields = false;
    this.foundEmpty = false;
    this.isSubmitted = false;
    this.isExporting = false;
    this.isFinalizing = false;
  }

  async ngOnInit(): Promise<void> {
    try {
      await this.initializeParams();
      await this.initializeForm();
    } catch (e) {
      this.toastService.toastErrorMessage(e.message);
    } finally {
      this.isLoading = false;
    }
  }

  setCondition($event) {
    this.selectedField = $event.value;
  }

  checkForInvalidCharacter(event: any, displayMessage = true) {
    // const value = event.hasOwnProperty('target') ? event.target.value : event;
    const value = typeof event === 'object' ? event.target.value : event;
    console.log(value);
    let isInvalid = false;
    if (value) {
      if (this.commonService.checkForEscapeCharacter(value)) {
        if(displayMessage) {
          this.toastService.toastErrorMessage(`Παρακαλούμε αφαιρέστε από την απάντησή σας χαρακτήρες όπως \\ \' \"`);
        }
        isInvalid = true;
      }
    }
    return isInvalid;
  }

  displayRow(row: any): boolean {
    if (!this.hasLinkedFields) {
      return true;
    }

    if (row.members.length > 0 && row.members.some(m => m.controls.length > 0) && row.members.some(m => m.hasOwnProperty('controls')) && row.members[0].controls[0].type === 'conditional-selector') {
      return true;
    }

    if (this.selectedField) {
      if (!row.hasLink) {
        return true;
      }

      if (row.hasLink) {
        return JSON.stringify(row.linkValue) === JSON.stringify(this.selectedField);
      }
    } else {
      return false;
    }

  }

  saveFile(data: any, filename: string) {
    const blob = new Blob([data], {type: 'application/octet-stream'});
    saveAs(blob, filename);
  }

  async fetchFile(file: any) {
    try {
      const blob: any = await this.fileService.getFile(`files/serveFile`, file.path);
      const openFileTypes = ['image/jpeg', 'image/png', 'application/pdf'];
      const exist = openFileTypes.some(type => type === blob.type);

      if (exist) {
        const finalImage = await this.commonService.blobToImage(blob);
        const newTab = window.open('about:blank', '_blank');
        newTab.document.write(`<div style="display: flex; flex: 1; flex-direction: column; justify-content: center; align-items: center;">
                                       <object style="margin-left: auto; margin-right:auto; width: 50%; height: 100vh; padding: 10px;" data=${finalImage} type="${blob.type}"></object>
                                       </div>`);
        newTab.document.close();
      } else {
        this.saveFile(blob, file.name);
      }

    } catch (e) {
      this.toastService.toastErrorMessage(e.serverMessage);
    }
  }

  async initializeForm() {
    let form;
    if (this.mode === 'author' || this.mode === 'reapply') {
      form = await this.resumeService.fetchResumeByUniqueTokenAndId(this.id, this.uniqueToken);

      try {
        const files = JSON.parse(form.files);
        if (Array.isArray(files)) {
          for (const file of files) {
            const temp = file.split('/');
            const name = temp[temp.length - 1];
            this.previewFiles.push({name, path: file});
          }
        }
      } catch (e) {
        console.log('no files');
      }

    } else if (this.mode === 'reapply') {
      form = await this.resumeService.fetchResumeByUniqueTokenAndId(this.id, this.uniqueToken);
      const files = JSON.parse(form.files);
      for (const file of files) {
        const temp = file.split('/');
        const name = temp[temp.length - 1];
        this.previewFiles.push({name, path: file});
      }
    } else {
      form = await this.resumeService.fetchResumeByUniqueId(this.uniqueId);
    }
    try {
      this.form = {
        settings: JSON.parse(form.settings),
        rows: JSON.parse(form.rows),
        questions: []
      };

      if (!this.form.settings.hasOwnProperty('language')) {
        this.form.settings.language = {
          multi: false,
          languages: [{id: 1, value: 'EL'}, {id: 2, value: 'EN'}],
          default: 1,
          preview: 1,
          position: 'end center'
        };
      } else {
        this.form.settings.language.default = this.form.settings.language.default = 1;
        this.form.settings.language.preview = this.form.settings.language.default;
      }


      if (this.previewParam) {
        this.form.settings.language.preview = this.previewParam;
      }

      this.hasLinkedFields = this.form.rows.some(r => r.hasLink);
      if (this.hasLinkedFields) {
        this.setDefaultConditionals();
      }
    } catch (e) {
      console.log(e);
    }
  }

  setDefaultConditionals() {
    let conditional: any = {};
    for (const row of this.form.rows) {
      for (const member of row.members) {
        if (!member.hasOwnProperty('hiddenValue')) {
          member.hiddenValue = '';
        }
        if (member.controls.length > 0 && member.controls.some(c => c.type === 'conditional-selector')) {
          member.hiddenValue = member.value;
          member.value = {};
          conditional = member;
        }
      }
    }

    if (conditional) {
      conditional.value = conditional.hiddenValue;
      this.selectedField = conditional.value;
    }
  }

  compareOptions(f1: any, f2: any): boolean {
    return f1 && f2 && f1.id === f2.id;
  }

  calculateFlex(members) {
    return (100 / members);
  }

  async initializeParams(): Promise<void> {
    return new Promise((resolve => {
      this.route.queryParams.subscribe(params => {
        this.uniqueId = params.uniqueId;
        this.uniqueToken = params.uniqueToken;
        this.mode = params.mode ? params.mode : 'new';
        this.id = +params.id;
        this.previewParam = params.l && params.l === 'en' ? 2 : 1;
        resolve();
      });
    }));
  }

  passCheckRequired(): boolean {
    const hasLink = this.form.rows.some(r => r.hasLink);
    if (!hasLink) {
      for (const row of this.form.rows) {
        for (const member of row.members) {
          if (member.isRequired && !member.value) {
            this.foundEmpty = true;
            return false;
          }
        }
      }
    } else {
      for (const row of this.form.rows) {
        for (const member of row.members) {
          if (member.isRequired && !member.value && row.hasLink && row.linkValue.value === this.selectedField.value) {
            this.foundEmpty = true;
            return false;
          } else {
            if (member.label && member.label.toLowerCase() === 'email') {
              if (!member.value || member.value.trim() === '') {
                this.foundEmpty = true;
                return false;
              }
            }
          }
        }
      }
    }

    return true;
  }

  shouldDisplayEmptyWarning(member: any) {
    return this.isSubmitted && member.isRequired && (!member.value || member.value === '');
  }

  async update() {
    try {
      this.isSubmitting = true;
      const questions = [];
      const rows = JSON.stringify(this.form.rows);
      for (const row of this.form.rows) {
        for (const member of row.members) {
          if (member.shouldExport) {
            questions.push(member);
          }
        }
      }

      const form = {
        settings: JSON.stringify(this.form.settings),
        rows,
        questions: JSON.stringify(questions),
        uniqueToken: this.uniqueToken,
        id: this.id
      };

      await this.resumeService.updateInternal(form);
      this.toastService.toastMessages('Η δήλωση ενημερώθηκε με επιτυχία');
    } catch (e) {
      this.toastService.toastErrorMessage(e.message);
    } finally {
      this.isSubmitting = false;
    }
  }

  async reapply() {
    try {
      this.isSubmitting = true;
      this.isSubmitted = true;
      if (!this.passCheckRequired()) {
        this.toastService.toastErrorMessage('Παρακαλούμε συμπληρώστε όλα τα υποχρεωτικά πεδία με το (*)');
        return false;
      }

      const formattedQuestions = this.formatQuestions();
      const twoFactorMember = formattedQuestions.twoFactorMember;

      const questions = formattedQuestions.questions;
      const rows = JSON.stringify(this.form.rows);

      const form = {
        settings: JSON.stringify(this.form.settings),
        rows,
        questions: JSON.stringify(questions),
        uniqueId: this.uniqueId,
        id: this.id,
        uniqueToken: this.uniqueToken
      };

      this.submittedForm = form;

      if (this.form.settings.hasTwoFactor && twoFactorMember) {
        try {
          const params = {
            identifier: twoFactorMember.value,
            type: twoFactorMember.twoFactor.selectedType === 'email' ? 1 : 2
          };
          await this.resumeService.createTFA(params);
        } catch (e) {
          this.toastService.toastErrorMessage(e.message);
        }
        this.twoFactor.display = true;
        this.twoFactor.identifier = twoFactorMember.value;

        let message = '';
        const preview = this.form.settings.language.preview;
        if (twoFactorMember.twoFactor.selectedType === 'email') {
          message = preview === 1 ? `Πληκτρολογήστε τον κωδικό που έχει αποσταλλεί στο email σας ${this.twoFactor.identifier}` : `Please fill in the code sent to your email ${this.twoFactor.identifier}`;
        } else {
          message = preview === 1 ? `Πληκτρολογήστε τον κωδικό που έχει αποσταλλεί στο κινητό σας ${this.twoFactor.identifier}` : `Please fill in the code sent to your mobile ${this.twoFactor.identifier}`;
        }

        this.twoFactor.message = message;
      } else {
        await this.updateForm();
      }

    } catch (e) {
      this.toastService.toastErrorMessage(e.message);
    } finally {
      this.isSubmitting = false;
    }
  }

  async updateForm() {
    const uniqueId = this.submittedForm.uniqueId;
    const uniqueToken = this.uniqueToken;
    this.submittedForm.recipient = {
      identifier: this.twoFactorField.value,
      type: this.twoFactorField.twoFactor.selectedType
    };

    const formattedQuestions = this.formatQuestions();
    const questions = formattedQuestions.questions;
    this.submittedForm.rows = JSON.stringify(this.form.rows);
    this.submittedForm.questions = JSON.stringify(questions);

    await this.resumeService.updateForm(this.submittedForm);
    await this.uploadFiles(uniqueId, uniqueToken);
    await this.router.navigate(['success']);
  }

  async submit() {
    try {
      this.isSubmitting = true;
      this.isSubmitted = true;
      if (!this.passCheckRequired()) {
        this.toastService.toastErrorMessage('Παρακαλούμε συμπληρώστε όλα τα υποχρεωτικά πεδία με το (*)');
        return false;
      }

      const formattedQuestions = this.formatQuestions();
      const twoFactorMember = formattedQuestions.twoFactorMember;

      const questions = formattedQuestions.questions;
      const rows = JSON.stringify(this.form.rows);

      const form = {
        settings: JSON.stringify(this.form.settings),
        rows,
        questions: JSON.stringify(questions),
        uniqueId: this.uniqueId
      };

      this.submittedForm = form;

      if (this.form.settings.hasTwoFactor && twoFactorMember) {
        try {
          const params = {
            identifier: twoFactorMember.value,
            type: twoFactorMember.twoFactor.selectedType === 'email' ? 1 : 2
          };
          await this.resumeService.createTFA(params);
        } catch (e) {
          this.toastService.toastErrorMessage(e.message);
        }
        this.twoFactor.display = true;
        this.twoFactor.identifier = twoFactorMember.value;

        let message = '';
        const preview = this.form.settings.language.preview;
        if (twoFactorMember.twoFactor.selectedType === 'email') {
          message = preview === 1 ? `Πληκτρολογήστε τον κωδικό που έχει αποσταλλεί στο email σας ${this.twoFactor.identifier}` : `Please fill in the code sent to your email ${this.twoFactor.identifier}`;
        } else {
          message = preview === 1 ? `Πληκτρολογήστε τον κωδικό που έχει αποσταλλεί στο κινητό σας ${this.twoFactor.identifier}` : `Please fill in the code sent to your mobile ${this.twoFactor.identifier}`;
        }

        this.twoFactor.message = message;
      } else {
        await this.submitForm();
      }

    } catch (e) {
      console.log(e);
      this.toastService.toastErrorMessage(e.message);
    } finally {
      this.isSubmitting = false;
    }
  }

  //#region helpers
  formatQuestions() {
    let twoFactorMember = null;

    const questions = [];
    for (const row of this.form.rows) {
      for (const member of row.members) {
        if (member.shouldExport) {
          if (member.twoFactor.isTwoFactorField) {
            twoFactorMember = member;
            this.twoFactorField = member;
          }
          questions.push(member);
        }
      }
    }

    return {twoFactorMember, questions};
  }
  checkedChange($event: MatCheckboxChange, member: any) {
    member.value = $event.checked;
  }

  radioChanged($event: MatRadioChange, member: any) {
    member.value = $event.value;
  }

  displayFieldName(member: any) {
    return +this.form.settings.language.preview === 2 ? member.labelEN : member.label;
  }

  displayRowName(row: any) {
    return +this.form.settings.language.preview === 2 ? row.title.textEN : row.title.text;
  }

  displayPlaceHolder(member: any) {
    return +this.form.settings.language.preview === 2 ? member.placeholderEN : member.placeholder;
  }

  displayValueLabel(member) {
    return +this.form.settings.language.preview === 2 ? member.valueEN : member.value;
  }

  setPreviewLanguage(id: number) {
    this.form.settings.language.preview = id;
  }

  //#endregion
  async sendTFA() {
    try {
      this.isFinalizing = true;
      await this.resumeService.confirmTFA({identifier: this.twoFactorField.value, value: this.twoFactor.value});
      if (this.mode === 'reapply') {
        await this.updateForm();
      } else {
        await this.submitForm();
      }
    } catch (e) {
      console.log(e);
      let message = '';
      if (e.hasOwnProperty('error')) {
        message = e.error.message;
      } else {
        message = e.serverMessage;
      }
      this.toastService.toastErrorMessage(message);
    } finally {
      this.isFinalizing = false;
    }
  }

  async submitForm() {
    try {
      this.submittedForm.recipient = {
        identifier: this.twoFactorField.value,
        type: this.twoFactorField.twoFactor.selectedType
      };
      console.log(this.twoFactorField);
    } catch (e) {
      console.log('no 2fa');
    }

    // const check = this.checkFormFormInvalidCharacters();
    // if (check.status) {
    //   this.toastService.toastErrorMessage(`To πεδίο ${check.member.label} περιέχει ασυνήθιστους χαρακτήρες. Παρακαλούμε διορθώστε το.`);
    //   return false;
    // }

    const formattedQuestions = this.formatQuestions();
    const questions = formattedQuestions.questions;
    this.submittedForm.rows = JSON.stringify(this.form.rows);
    this.submittedForm.questions = JSON.stringify(questions);
    const {uniqueId, uniqueToken} = await this.resumeService.submitForm(this.submittedForm);
    await this.uploadFiles(uniqueId, uniqueToken);
    await this.router.navigate(['success']);
  }

  checkFormFormInvalidCharacters() {
    for (const row of this.form.rows) {
      for (const member of row.members) {
          if (this.memberHasControls(member) && this.validMemberForCheck(member) && member.value) {
            const value = typeof member.value === 'object' ? member.value.value : member.value;
            if (this.checkForInvalidCharacter(value, false)) {
              return {member, status: true};
            }
          }
      }
    }
    return {member: null, status: false};
  }

  memberHasControls(member): boolean {
    return member.controls.length > 0;
  }

  validMemberForCheck(member): boolean {
    return member.controls[0].type !== 'label';
  }

  isTFADisabled(): boolean {
    return !this.twoFactor.value || this.twoFactor.value.length < 6;
  }

  onFileSelected(event: any, member: any) {
    const exist = this.files.some(f => f.key === member.key);
    const file = event.target.files[0];
    if (exist) {
      const index = this.files.findIndex(f => f.key === member.key);
      if (index !== -1) {
        this.files[index].file = file;
      }
    } else {
      this.files.push({key: member.key, file});
    }
    member.hiddenValue = file.name;
  }

  async uploadFiles(uniqueId: string, uniqueToken: string) {
    try {
      if (this.files.length > 0) {
        const formData = new FormData();
        for (const record of this.files) {
          formData.append('file', record.file, record.file.name);
        }

        formData.append('filesPath', 'TestPath');

        const endpoint = `resumes/submit-files?uniqueId=${uniqueId}&uniqueToken=${uniqueToken}`;
        await this.fileService.uploadMultipleFiles(endpoint, formData).subscribe((response) => {
          console.log(response);
        });
      }
    } catch (e) {
      console.log(e);
      this.toastService.toastErrorMessage(e.serverMessage);
    }
  }

  async displayFile(hiddenValue: any) {
    console.log(hiddenValue);
    console.log(this.previewFiles);
    const file = this.previewFiles.find(f => f.name === hiddenValue);
    if (file) {
      await this.fetchFile(file);
    }
  }
}
